<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Adicionar Resposta</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Unidade:
                      </label>
                      <v-select :options="unidades" :label="'unidade_nome'" :reduce="(unidades) => unidades.id"
                        v-model="resposta.unidade_id"></v-select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Pergunta:
                      </label>
                      <v-select :options="perguntas" :label="'titulo'" :reduce="(perguntas) => perguntas.id"
                        v-model="resposta.pergunta_id"></v-select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Título:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="resposta.titulo" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Ordem:
                      </label>
                      <input autocomplete="new-password" type="text" id="Name" class="form-control"
                        v-model="resposta.ordem" placeholder="" />
                    </div>
                    <div class="form-group col-md-3">
                      <label for="Name">
                        <span class="required">*</span> Tipo Resposta:
                      </label>
                      <select v-model="resposta.tipo_resposta" class="form-control">
                        <option value="I">Imagem</option>
                        <option value="T">Texto</option>
                      </select>
                    </div>
                    <div class="form-group col-md-4" v-if="resposta.tipo_resposta == 'I'">
                      <label for="Name">
                        <span class="required">*</span> Imagem:
                      </label>
                      <input autocomplete="new-password" type="file" id="path_imagem" class="form-control"
                        placeholder="" />
                    </div>
                    <div class="form-group col-md-2">
                      <label for="Name">
                        <span class="required">*</span> Aciona Identificador:
                      </label>
                      <select v-model="resposta.aciona_identificador" class="form-control">
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                      </select>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="password">
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="resposta.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group">
                    <div class="block text-right">
                      <router-link to="/respostas" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      departments: [],
      change_password: true,
      resposta: {
        status: '1',
      },
      unidades: [],
      perguntas: [],
      errors: undefined,

      previewImage: null,
    };
  },
  computed: {},
  methods: {

    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let imagem = document.getElementById("path_imagem");

      fd.append("unidade_id", self.resposta.unidade_id);
      fd.append("pergunta_id", self.resposta.pergunta_id);
      fd.append("titulo", self.resposta.titulo);
      fd.append("ordem", self.resposta.ordem);
      fd.append("tipo_resposta", self.resposta.tipo_resposta);
      fd.append("aciona_identificador", self.resposta.aciona_identificador);
      fd.append("status", self.resposta.status);

      fd.append("_method", "POST");

      if (imagem && imagem.files[0]) {
        fd.append("path_imagem", imagem.files[0]);
    }

      if (self.resposta.id) {
        fd.append("id", self.resposta.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "respostas";
      let fd = self.makeFormData();

      if (self.resposta.id) {
        self.resposta._method = "PUT"
        api += "/" + self.resposta.id;
      }

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/respostas");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      var self = this;

      self.naoLocalizado = false;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.resposta.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.resposta.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};
              $("#inputNumero").focus();
              self.naoLocalizado = true;
              return;
            }
            self.endereco = endereco;
            self.resposta.logradouro = self.endereco.logradouro;
            self.resposta.bairro = self.endereco.bairro;
            self.resposta.uf = self.endereco.uf;
            self.resposta.cidade = self.endereco.localidade;
            $("#inputNumero").focus();
          }
        );
      }
    },
    getResposta: function (id) {
      const self = this;
      const api = self.$store.state.api + "respostas/" + id;

      axios
        .get(api)
        .then((response) => {
          self.resposta = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getPerguntas: function () {
      const self = this;
      const api = self.$store.state.api + "perguntas";

      axios
        .get(api)
        .then((response) => {
          self.perguntas = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

  },
  mounted: function () {
    const self = this;

    self.getUnidades();
    self.getPerguntas();

    let id = self.$route.params.id;
    if (id) {
      self.getResposta(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>